import { Component, OnInit, signal } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
  FormsModule,
} from '@angular/forms';
import { first } from 'rxjs/operators';
import { AuthenticationService } from '../Authentication/services/authentication.service';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import {
  MatButtonToggleGroup,
  MatButtonToggleModule,
} from '@angular/material/button-toggle';
import { ForgotpasswordComponent } from '../forgotpassword/forgotpassword.component';
import { environment } from '../../../environments/environment.prod';
import { ToastService } from '../../Services/toast/toast.service';
import { MatDividerModule } from '@angular/material/divider';
import { TranslateDirective } from '../Utilites/Directives/translate.directive';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: true,
  imports: [
    ForgotpasswordComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatButtonToggleModule,
    MatDividerModule,
    MatButtonToggleGroup,
    TranslateDirective
  ],
})
export class LoginComponent implements OnInit {
  form!: FormGroup;
  formload_flag = false;
  submitted = false;
  loading = false;
  loginerror = false;
  forgotpasswordflag = false;
  showPassword: boolean = false;

  dominName: string = '';
  loginbanner: string = '';
  returnUrl: string | undefined;
  error: string = '';
  usermsg: string = '';

  hide = signal(true);

  roles = [
    { value: 'student', display: 'Student' },
    { value: 'Staff', display: 'Staff' },
  ];
  selectedrole: string = ''; // default = 'student'

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private toast: ToastService
  ) {
    if (this.authenticationService.userValue !== undefined) {
      this.router.navigate(['/dashboard']);
    }
  }

  ngOnInit(): void {
    this.dominName = this.getOrgFromHost();
    this.loginbanner = `${environment.ASSET_URL}${environment.ASSET_CONTAINER}/assets/Login_Banners/LoginBanner.jpg`;

    this.form = this.fb.group({
      userid: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    });

    this.returnUrl = this.route.snapshot?.queryParams['returnUrl'] || '/';
  }

  get f() {
    return this.form.controls;
  }

  getRoleIcon(role: string): string {
    const iconMap: { [key: string]: string } = {
      student: 'school',
      staff: 'work',
      employee: 'badge',
      admin: 'admin_panel_settings',
      teacher: 'person',
    };
    return iconMap[role.toLowerCase()] || 'person';
  }

  getOrgFromHost(): string {
    if (typeof window !== 'undefined') {
      const host = window.location.hostname;
      if (
        host === 'localhost' ||
        host === '127.0.0.1' ||
        host.startsWith('192.') ||
        host.startsWith('10.')
      ) {
        return 'dbraei';
      }

      const parts = host.split('.');
      return parts.length >= 2 ? parts[1] : 'default';
    }
    return 'default';
  }

  onValChange(val: string): void {
    this.selectedrole = val;
    this.form.reset();
    this.formload_flag = true;
    this.loginerror = false;
  }

  forgotflag(): void {
    this.forgotpasswordflag = true;
  }

  addItem(newItem: boolean): void {
    this.forgotpasswordflag = newItem;
  }

  onSubmit(): void {
    this.submitted = true;
    this.loginerror = false;

    if (this.form.invalid) return;

    const { userid, password } = this.form.value;
    this.loading = true;
    setTimeout(() => {
      this.authenticationService
        .login(userid, password, this.selectedrole)
        .pipe(first())
        .subscribe(
          (data) => {
            if (data.status) {
              if (this.selectedrole === 'student') {
                this.router
                  .navigate(['/studentview'], {
                    queryParams: { dataId: data.data.id },
                  })
                  .then(() => (window.location.href = this.router.url));
              } else {
                const onboarded =
                  data.data.onboarding_status ||
                  data.data.sub_orgs_data?.[0]?.onboarding_status;

                if (!data.data.onboarding_status) {
                  this.router
                    .navigate(['/employeeview'], {
                      queryParams: { dataId: data.data.id },
                    })
                    .then(() => (window.location.href = this.router.url));
                } else if (!data.data.sub_orgs_data?.[0]?.onboarding_status) {
                     this.router.navigate(['/onboarding'])
                    .then(() => (window.location.href = this.router.url));
                } else {
                    this.router
                    .navigate(['/employeeview'], {
                      queryParams: { dataId: data.data.id },
                    })
                    .then(() => (window.location.href = this.router.url));
                }
              }
            }else{
                    this.usermsg = data.message;
                    this.loading = false;
                  }
          },
          (err) => {
            this.error =
              err.error?.message ||
              'No internet connection. Please check your network and try again.';
            this.toast.showToast('danger', this.error);
            this.loading = false;
          }
        );
    }, 2000);
  }
}
